import { create } from 'zustand';

const useTourNotificationStore = create((set) => ({
  newBookingCounts: {},
  incrementNewBookingCount: (propertyId) =>
    set((state) => {
      if (!propertyId) return state;
      return {
        newBookingCounts: {
          ...state.newBookingCounts,
          [propertyId]: (state.newBookingCounts[propertyId] || 0) + 1,
        },
      };
    }),
  clearNewBookingCount: (propertyId) =>
    set((state) => {
      if (!propertyId) return state;
      if (!state.newBookingCounts[propertyId]) return state;
      return {
        newBookingCounts: {
          ...state.newBookingCounts,
          [propertyId]: 0,
        },
      };
    }),
}));

export default useTourNotificationStore;
